<template>
  <div class="banner-swiper">
    <swiper ref="bannerSwiper" :options="swiperOptions" class="swiper-container">
      <swiper-slide v-for="(item, idx) in bannerImages" :key="idx">
        <picture>
          <source v-if="item.img3" :srcset="item.img3" media="(max-width: 575px)" />
          <source v-if="item.img2" :srcset="item.img2" media="(max-width: 800px)" />
          <source v-if="item.img11" :srcset="item.img11" media="(max-width: 1200px)" />
          <source :srcset="item.img1" />
          <img :src="item.img1" class="banner-img" loading="lazy" alt="" />
        </picture>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'BannerSwiper',
  components: { Swiper, SwiperSlide },
  props: {
    brand: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      swiperOptions: {
        loop: true,
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false,
        // },
        autoplay: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        speed: 600,
      },
    }
  },
  computed: {
    bannerImages() {
      const prefix = this.brand?.title ? `${this.brand.title}_` : this.brand?.name ? `${this.brand.name}_` : ''
      if (!prefix) return []
      try {
        const ctx = require.context('@/assets/img', false, /\.(jpg|png|jpeg)$/)
        const keys = ctx
          .keys()
          .filter((k) => k.startsWith(`./${prefix}`))
          .sort()
        // 按基础名称分组 (去掉 _1/_2/_3 后缀)
        const groups = {}
        keys.forEach((k) => {
          // 从 ./zeekr_7x_1.jpg 提取 base: ./zeekr_7x
          const base = k.replace(/_(\d+)\.(jpg|png|jpeg)$/, '')
          if (!groups[base]) groups[base] = {}
          const sizeMatch = k.match(/_(\d+)\.(jpg|png|jpeg)$/)
          const size = sizeMatch ? sizeMatch[1] : '1'
          groups[base][`img${size}`] = ctx(k)
        })
        // 转为数组，确保每项至少有 img1
        return Object.values(groups).filter((g) => g.img1)
      } catch (e) {
        return []
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.banner-swiper {
  width: 100%;
  position: relative;

  .swiper-container {
    width: 100%;
    height: 80vh;
  }

  .banner-img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

/* 矩形分页器样式 */
::v-deep .swiper-pagination-bullet {
  width: 24px;
  height: 4px;
  border-radius: 0;
  background: rgba(255, 255, 255, 0.6);
  opacity: 1;
  margin: 0 4px;
}

::v-deep .swiper-pagination-bullet-active {
  width: 32px;
  background: #fff;
}

/* 手机端适配 */
@media (max-width: 575px) {
  .banner-swiper .swiper-container {
    height: 65vh;
  }
}
</style>
